import { render, staticRenderFns } from "./CrudData.vue?vue&type=template&id=7537769d"
import script from "./CrudData.vue?vue&type=script&lang=js"
export * from "./CrudData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports